<template>
    <el-dialog title="增加关联客户" :visible.sync="relatedCompanyVisible" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" custom-class="custom-form-dialog">
        <div class="related-company-add-content">
            <el-input placeholder="请输入客户名称" v-model="searchForm.keyword" class="filter-input" size="small" clearable @clear="onSearch" @keyup.enter.native="onSearch">
                <i slot="suffix" class="iconfont icon-sousuo" @click="onSearch"></i>
            </el-input>
            <div class="select-company-wrap">
                <div class="flex-item-title">
                    <el-checkbox :indeterminate="companySelectsLen > 0 && companySelectsLen < relatedCompanyList.length" v-model="companyAllChecked"
                        @change="handleCompanyAllChange"></el-checkbox><span>已选客户（{{ companySelectsLen }}）</span>
                </div>
                <div class="flex-item-content">
                    <ul v-infinite-scroll="customerListLoadMore" :infinite-scroll-delay="100" :infinite-scroll-immediate="false">
                        <li v-for="item in relatedCompanyList" :key="item.id" @click.stop="handletCompanyCheckChange(item)">
                            <el-checkbox v-model="item.checked" @change="handletCompanyCheckChange(item)"></el-checkbox>
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">添加</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetUnrelatedCustomers, AddRelateCustomer } from "@/api";
export default {
    name: "RelatedCompanyAdd",
    props: {
        relatedCompanyVisible: {
            type: Boolean,
            default: false,
        },
        customer_id: "",
    },
    data() {
        return {
            loading: false,
            searchForm: {
                keyword: "",
            },
            companyAllChecked: false,
            relatedCompanyList: [
                // { id: 1, name: "公司名称1" },
                // { id: 2, name: "北京澜景科技有限公司" },
            ],
            btnDisabled: false,
            pagination: {
                pageNum: 1,
                total: 0,
            },
        };
    },
    computed: {
        companySelectsLen() {
            return this.relatedCompanyList.filter((item) => item.checked).length;
        },
    },
    created() {
        this.onSearch();
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:relatedCompanyVisible", false);
        },
        handleCompanyAllChange(checked) {
            this.relatedCompanyList.forEach((item) => {
                this.$set(item, "checked", checked);
            });
        },
        handletCompanyCheckChange(item) {
            this.$set(item, "checked", !item.checked);
            // 获取是否全部选中了
            this.companyAllChecked = this.relatedCompanyList.every((item) => item.checked);
        },
        customerListLoadMore() {
            if (this.loading || this.relatedCompanyList.length == this.pagination.total) {
                return false;
            }
            this.pagination.pageNum += 1;
            this.getCustomerPrivateList();
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.pagination.total = 0;
            this.relatedCompanyList = [];
            this.getCustomerPrivateList();
        },
        // 获取私海客户列表
        getCustomerPrivateList() {
            this.loading = true;
            GetUnrelatedCustomers({
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: 10,
                customer_id: this.customer_id
            })
                .then((res) => {
                    if (res.code == 200) {
                        const { list, total } = res.data;
                        this.relatedCompanyList = this.relatedCompanyList.concat(list || []);
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleDialogConfirm() {
            const checkedList = this.relatedCompanyList.filter((item) => item.checked);
            if (!checkedList.length) return this.$message.error("请选择关联客户");
            const params = {
                customer_id: this.customer_id,
                relate_customer_ids: checkedList.map((item) => item.id),
            };
            this.btnDisabled = true;
            this.loading = true;
            AddRelateCustomer(params)
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success(res.message);
                        this.$emit("update:relatedCompanyVisible", false);
                        this.$emit("updateCallback");
                    }
                    this.btnDisabled = false;
                    this.loading = false;
                })
                .catch(() => {
                    this.btnDisabled = false;
                    this.loading = false;
                });
        },
    },
};
</script>
<style lang="scss">
.related-company-add-content {
    .filter-input {
        .el-input__inner {
            height: 32px;
            line-height: 32px;
        }

        .el-input__suffix {
            right: 16px;
            line-height: 32px;
        }
    }

    .select-company-wrap {
        margin-top: 16px;
        border-radius: 6px;
        height: 404px;
        border: 1px solid rgba(243, 243, 243, 1);
        display: flex;
        flex-direction: column;

        .flex-item-title {
            padding: 0 12px;
            height: 38px;
            line-height: 38px;
            border-radius: 6px 6px, 0px, 0px;
            background: rgba(237, 240, 244, 1);

            &>span {
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                margin-left: 8px;
            }
        }

        .flex-item-content {
            flex: 1;
            padding: 8px 8px 0 4px;
            overflow: auto;

            li {
                margin-bottom: 4px;
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                cursor: pointer;

                &:hover {
                    border-radius: 4px;
                    background: rgba(0, 0, 0, 0.04);
                }
            }
        }
    }

    .el-checkbox {
        font-size: 16px;

        .el-checkbox__inner {
            width: 16px;
            height: 16px;
        }

        &.is-checked {
            .el-checkbox__inner {
                &::after {
                    top: 2px;
                    left: 5px;
                }
            }
        }

        .is-indeterminate {
            .el-checkbox__inner {
                background-color: #ffffff;
                border-color: #1990ff;

                &::before {
                    width: 8px;
                    height: 8px;
                    opacity: 1;
                    border-radius: 1px;
                    background: #1990ff;
                    transform: scale(1);
                    left: 3px;
                    top: 3px;
                }
            }
        }
    }
}
</style>
